<template>
  <div class="store-authorize-tip" v-show="visible" :class="{'lang-en': ['en_US', 'ko_KR'].includes(currentLang)}">
    <div class="tip-mask"></div>
    <div class="tip-main" :style="{transform: `translate(-50%, calc(-50% - ${40 * scale}px)) scale(${scale})`}">
      <div class="tip-main__logo">
        <img :src="logoImg[currentLang]" alt="">
      </div>
      <div class="tip-main__title">{{ $t('store-tip.title') }}</div>
      <div class="tip-main__subtitle">
        <span>
          <i style="left: -20px"></i>
          {{ $t('store-tip.subtitle') }}
          <i style="right: -20px"></i>
        </span>
      </div>
      <div class="tip-main__guide">
        <span>{{ $t('store-tip.guide') }}</span>
      </div>
      <ul class="tip-main__funs">
        <li v-for="i in func" :key="i.name">
          <div class="icon">
            <i class="iconfont" :class="i.icon"></i>
          </div>
          <div class="info" v-html="$t(i.name)"></div>
        </li>
      </ul>
      <a-checkbox v-model="notremind"  class="tip-main__remind">
        {{ $t('store-tip.remind') }}
      </a-checkbox>
      <div class="tip-main__btn" @click="toAuth">{{ $t('store-tip.btn') }}</div>
      <div class="tip-main__close" @click="handleClose">
        <icon-font type="gb-icon-guanbi1"></icon-font>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { STORE_AUTHORIZATION_NO_DISPLAY } from '@/store/mutation-types'
import { findPane } from '@/store/_util/util'

export default {
  name: 'storeAuthorizeTip',
  data () {
    return {
      scale: 1,
      visible: false,
      notremind: false,
      logoImg: {
        'zh_CN': require('@/assets/authstore_logo-cn.png'),
        'en_US': require('@/assets/authstore_logo-en.png'),
        'ko_KR': require('@/assets/authstore_logo-en.png')
      },
      func: [
        {
          icon: 'gb-icon-anquan',
          name: 'store-tip.info-1'
        },
        {
          icon: 'gb-icon-shuju',
          name: 'store-tip.info-2'
        },
        {
          icon: 'gb-icon-lightning',
          name: 'store-tip.info-3'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['activeKey', 'menus', 'currentLang'])
  },
  watch: {
    'activeKey': {
      handler: function (key) {
        if (this.$ls.get(STORE_AUTHORIZATION_NO_DISPLAY)) return
        const found = findPane(this.menus, { key, lastMenu: 2 })
        if (found?.tab === '平台店铺授权') {
          this.visible = false
        } else {
          this.visible = true
          let scale = window.innerHeight / 1070
          this.scale = scale > 1 ? 1 : scale
        }
      },
      immediate: true
    }
  },
  methods: {
    handleClose () {
      if (this.notremind) {
        const now = +new Date()
        const last = new Date().setHours(23, 59, 59, 999)
        this.$ls.set(STORE_AUTHORIZATION_NO_DISPLAY, true, last - now)
      }
      this.visible = false
    },
    toAuth () {
      const found = findPane(this.menus, { tab: '平台店铺授权', lastMenu: 2 })
      if (found) {
        this.$store.dispatch('entry/SetActiveKey', { key: found.key })
      } else {
        this.$message.warning(this.$t('layout.error-401'))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.store-authorize-tip {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .tip-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
  .tip-main {
    position: absolute;
    left: 50%;
    top: 50%;
    background: url('~@/assets/authstore.png') no-repeat center;
    width: 702px;
    height: 794px;
    z-index: 2;
    padding: 150px 120px 0 120px;
    text-align: center;
    font-family: '思源黑体', PingFangSC-Regular, PingFang SC, '微软雅黑';
    * {
      user-select: none !important;
    }
    &__logo {
      text-align: center;
    }
    &__title {
      margin-top: 15px;
      font-weight: bold;
      font-size: 50px;
      line-height: 1.2;
      background: linear-gradient(-90deg, #bd5628 0%, #eb9e56 49.853515625%, #bd5628 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color:transparent;
    }
    &__subtitle {
      width: 400px;
      margin: 20px auto;
      font-size: 16px;
      color: #cc7839;
      line-height: 35px;
      background: linear-gradient(-90deg, rgba(255, 226, 189, 0.21) 0%, rgba(245, 188, 114, 0.21) 48%, rgba(247, 222, 186, 0.21) 100%);
      span {
        position: relative;
        i {
          position: absolute;
          transform-origin: center center;
          transform: rotate(45deg) translate(0, -50%);
          display: block;
          width: 8px;
          height: 8px;
          border: 1px solid #CF8750;
          top: 50%;
        }
        &::before, &::after {
          content: '';
          position: absolute;
          width: 37px;
          height: 1px;
          background: linear-gradient(-90deg, #CF8750 0%, #F6E6D0 99%);
          left: -70px;
          top: 54%;
        }
        &::after{
          left: auto;
          right: -70px;
          transform: rotate(180deg);
        }
      }
    }
    &__guide {
      margin-top: 80px;
      color: #E07865;
      background: linear-gradient(0deg, rgba(249, 236, 135, 0.76) 0%, rgba(238, 174, 91, 0.76) 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: bold;
      font-size: 34px;
    }
    &__funs {
      display: flex;
      justify-content: space-between;
      // width: 420px;
      margin: 22px auto;
      padding: 0;
      li {
        width: 150px;
        list-style: none;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
      }
      .icon {
        width: 100%;
        height: 63px;
        line-height: 68px;
        position: relative;
        &::before, &::after {
          position: absolute;
          content: '';
          display: block;
          width: 63px;
          height: 63px;
          background: linear-gradient(126deg, #F9EC87 0%, #DA8A23 100%);
          border-radius: 50%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
        }
        &::after {
          width: 61px;
          height: 61px;
          background: RGBA(47, 45, 48, 1);
          z-index: 3;
        }
        .iconfont {
          position: relative;
          z-index: 5;
          font-size: 32px;
          background: linear-gradient(126deg, #F9EC87 0%, #DA8A23 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      .info {
        color: #F5CF8B;
        font-size: 16px;
        margin-top: 20px;
      }
    }
    &__remind {
      margin: 0 auto 10px auto;
      color: rgba(229, 193, 129, 0.62);
      font-size: 16px;
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      padding: 10px 0;
      /deep/.ant-checkbox-checked, /deep/.ant-checkbox {
        top: 0;
      }
      /deep/.ant-checkbox-inner {
        background: transparent;
        border-color: rgba(232, 196, 133, 0.62);
      }
      /deep/.ant-checkbox-checked .ant-checkbox-inner {
        background: rgba(232, 196, 133, 0.62);
        border-color: transparent !important;
      }
      /deep/.ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: rgba(232, 196, 133, 0.62);
      }
      &:hover {
        /deep/.ant-checkbox-inner, /deep/.ant-checkbox-checked::after  {
          border-color: rgba(232, 196, 133, 0.62);
        }
      }
    }
    &__btn {
      margin: 0 auto;
      width: 331px;
      height: 78px;
      background: linear-gradient(-90deg, #f2af5d 0%, #fcebc1 50%, #f2af5d 100%);
      border-radius: 39px;
      color: #6c250f;
      line-height: 78px;
      font-size: 30px;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background: linear-gradient(-90deg, #f2af5d 10%, #fcebc1 50%, #f2af5d 90%);
        box-shadow: 0 0 20px rgba(244, 189, 125, 0.5)
      }
    }
    &__close {
      display: inline-block;
      margin-top: 30px;
      font-size: 60px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1
    }
  }
  &.lang-en {
    .tip-main {
      &__title, &__guide, &__btn {
        font-size: 22px;
      }
      &__funs {
        margin: 22px -22px;
        & > li {
          flex: 1;
        }
      }
      &__funs .info {
        font-size: 13px;
      }
    }
  }
}
</style>
